<script>
export default{
  name: "statewide-make"
}
</script>

<template>
  <div class="main d-flex">
    <div class="main-block">
      <div class="main-title">
        shop genuine oem parts
      </div>
      <div class="main-subtitle">
        Select a <span>Manufacturer</span> to start
      </div>

      <div class="cards-statewide d-flex">
        <div class="card-statewide" @click="$emit('selected', 'Alfa Romeo')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/alfa-romeo.png" height="105" width="105"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Audi')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/audi.png" height="120" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'BMW')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/bmw.webp" height="120" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'BYD')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/byd.png" height="70" width="140"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Cupra')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/cupra.png" height="75" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Chrysler')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/chrysler.png" height="35" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Chery')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/chery.webp" height="93" width="130"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Fiat')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/fiat.png" height="90" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Ford')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/ford.png" height="45" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'GWM')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/gwm.png" height="70" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Holden')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/holden.png" height="120" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Hyundai')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/hyundai.png" height="70" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Isuzu')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/isuzu.png" height="40" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Jac')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/jac.png" height="120" width="120"/>
          </div>
        </div>

        <div class="card-statewide" @click="$emit('selected', 'Jaguar')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/jaguar.png" height="60" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Jeep')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/jeep.png" height="110" width="140"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Kia')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/kia.png" height="50" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Land-Rover')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/land-rover.png" height="70" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'LDV')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/ldv.png" height="100" width="150"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Lexus')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/lexus.png" height="73" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Mazda')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/mazda.png" height="120" width="120"/>
          </div>
        </div>

        <div class="card-statewide" @click="$emit('selected', 'Mersedes-Benz')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/mersedes-benz.png" height="120" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Mini')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/mini.png" height="120" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Mitsubishi')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/mitsubishi.png" height="120" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'MG')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/mg.png" height="120" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Nissan')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/nissan.png" height="90" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Polestar')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/polestar.png" height="80" width="140"/>
          </div>
        </div>

        <div class="card-statewide" @click="$emit('selected', 'Porshe')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/porshe.png" height="105" width="92"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'RAM')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/ram.png" height="100" width="90"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Renault')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/renault.png" height="120" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Ssangyong')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/ssangyong.png" height="80" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Suzuki')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/suzuki.png" height="110" width="110"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Toyota')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/toyota.png" height="120" width="140"/>
          </div>
        </div>

        <div class="card-statewide" @click="$emit('selected', 'Volkswagen')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/volkswagen.png" height="100" width="100"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Volvo')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/volvo.png" height="125" width="125"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Abarth')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/abarth.png" height="130" width="200"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Aston Martin')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/aston-martin.png" height="55" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Bentley')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/bentley.png" height="58" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Brabus')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/brabus.png" height="115" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Ferrari')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/ferrari.png" height="120" width="85"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Lamborghini')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/lamborghini.png" height="100" width="105"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Lotus')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/lotus.png" height="105" width="105"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'McLaren')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/mclaren.png" height="35" width="140"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Morgan')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/morgan.png" height="70" width="130"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Pagani')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/pagani.png" height="63" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Singer')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/singer.png" height="50" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Sikkens')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/sikkens.png" height="65" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', '3M')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/3m.png" height="100" width="125"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Ppg')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/ppg.png" height="165" width="180"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Hayman-Reese')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/hayman-reese.png" height="120" width="120"/>
          </div>
        </div>
        <div class="card-statewide" @click="$emit('selected', 'Kovax')">
          <div class="card-statewide-brand">
            <img src="../../../public/auto-logo/kovax.png" height="40" width="120"/>
          </div>
        </div>
      </div>
    </div>
    <div class="right-banner">
      <div class="right-banner-item-capricorn">
        <img src="../../../public/img/capricornLogo-1024x217.png" height="50" width="220">
        <div class="right-banner-item-capricorn-subtitle">
          PREFERRED SUPPLIER
        </div>
      </div>
      <div class="right-banner-item-purple">
        <div>FAST Service</div>
        <div>FAST Delivery</div>
      </div>
      <div  class="right-banner-item-grey">
        <div>Australia`s leading</div>
        <div>GENUINE Parts Hub</div>
      </div>
      <div class="right-banner-item-white">
        <div class="right-banner-item-white-elem">
          <div class="right-banner-item-white-elem-title">
            Connect with In-House Experts
          </div>
          <div>
            We know the products
          </div>
        </div>

        <div class="right-banner-item-white-elem">
          <div class="right-banner-item-white-elem-title">
            Shop with Confidence
          </div>
          <div>
            Your information is Safe
          </div>
        </div>

        <div class="right-banner-item-white-elem">
          <div class="right-banner-item-white-elem-title">
            Manufacturer Warranty
          </div>
        </div>
      </div>
      <div class="right-banner-item-yellow">
        We partner with some of Australia`s leading Genuine parts dealerships to
        <span>
          guarantee premium parts, reliable service and quality protection.
        </span>
      </div>

    </div>

  </div>
</template>

<style scoped>
.main-block{
  width: 930px;
  margin-right: 40px
}
.right-banner{
  margin-top: 30px;
  width: 230px;
  font-size: 20px;
  position: sticky;
  top: 5px;
  height: 100%;
}
.right-banner-item-capricorn{
  margin-top: 80px;
  border: 3px solid #382261;
  margin-bottom: 40px;
}
.right-banner-item-capricorn img{
  margin: 35px 5px;
}
.right-banner-item-capricorn-subtitle{
  background-color: #382261;
  text-align: center;
  color: white;
  font-size: 18px;
  font-weight: 500;
  padding: 6px;
}
.right-banner-item-purple{
  background-color: #562a78;
  color: #fdcb2d;
  border-radius: 5px;
  font-weight: 600;
  padding: 20px;
  text-align: center;
}
.right-banner-item-grey{
  background-color: #d7d7d7;
  color: rgb(88, 43, 121);
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  font-weight: 600;
}
.right-banner-item-white{
  font-weight: 400;
  padding: 40px 20px;
  font-size: 16px;
}
.right-banner-item-white-elem{
  margin-bottom: 20px;
}
.right-banner-item-white-elem-title{
  font-weight: 800;
}
.right-banner-item-yellow{
  background-color: #fdd864;
  border-radius: 5px;
  font-weight: 500;
  padding: 40px 20px;
  line-height: 30px;
  font-size: 17px;
  text-align: center;
  margin-bottom: 20px;
}
.right-banner-item-yellow span{
  font-weight: 800;
}
.main-title{
  font-size: 50px;
  color: rgb(88, 43, 121);
  text-align: center;
  margin-top: 5px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.main-subtitle{
  font-size: 26px;
  color: rgb(88, 43, 121);
  text-align: center;
  font-weight: 400;
  margin-top: -11px;
  letter-spacing: 1.5px;
}
.main-subtitle span{
  font-weight: 800;
}
.cards-statewide{
  flex-wrap: wrap;
  justify-content: space-between;
}
.card-statewide{
  border: 1px solid black;
  margin: 5px;
  padding: 10px 0;
  width: 138px;
  position: relative;
  height: 130px;
  cursor: pointer;
}
.card-statewide:hover{
  background-color: #f0f2f1;
}
.card-statewide img {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}

@media (max-width: 1200px) {
  .main-title{
    font-size: 30px;
    margin-top: 15px;
  }
  .main-subtitle{
    font-size: 25px;
    margin-top: 10px;
  }
  .main-block{
    width: auto;
  }
}
@media (max-width: 700px) {
  .header-block .header-block-logo img{
    padding-top: 15px;
    width: 110px;
  }
  .main-title{
    font-size: 22px;
    margin-top: 10px;
  }
  .main-subtitle{
    font-size: 18px;
    margin-top: 10px;
  }
  .right-banner{
    display: none;
  }
  .main-block{
    margin-right: 0;
  }
}
@media (max-width: 460px){
  .cards-statewide{
    justify-content: space-around;
  }
}
@media (max-width: 310px){
  .cards-statewide{
    justify-content: center;
  }
}
</style>
